import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import colors from '../../style/colors';

export const sizes = {
  xxs: { propotion: 12, thickness: 1 },
  xs: { propotion: 15, thickness: 2 },
  sm: { propotion: 26, thickness: 3 },
  md: { propotion: 50, thickness: 4 },
  lg: { propotion: 80, thickness: 8 },
};

export const variants = {
  white: () => ({ borderColor: colors.white }),
  action: (props: any) => ({ borderColor: props.theme.actionColor }),
  gray: () => ({ borderColor: colors.gray400 }),
};

interface SpinnerProps {
  size?: keyof typeof sizes;
  className?: string;
  absoluteCenter?: boolean;
  variant?: keyof typeof variants;
  style?: React.CSSProperties;
}

const SpinnerWrapper = styled.div<SpinnerProps>`
  display: inline-block;
  position: relative;
  width: ${props => `${sizes[props.size || 'lg'].propotion}px`};
  height: ${props => `${sizes[props.size || 'lg'].propotion}px`};

  > div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${props => `${sizes[props.size || 'lg'].propotion}px`};
    height: ${props => `${sizes[props.size || 'lg'].propotion}px`};

    border: ${props => `${sizes[props.size || 'lg'].thickness}px`} solid;
    border-radius: 50%;
    animation: spinner 0.6s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${props => variants[props.variant || 'action']?.(props)?.borderColor} transparent transparent
      transparent;
  }

  .spinner div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .spinner div:nth-child(2) {
    animation-delay: -0.3s;
  }

  .spinner div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &.absolute-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const Spinner = ({ className, size = 'md', absoluteCenter, variant, style }: SpinnerProps) => {
  return (
    <SpinnerWrapper
      variant={variant}
      style={style}
      role="status"
      aria-live="polite"
      aria-label="Loading"
      size={size}
      data-name={'spinner-container'}
      data-testid={'spinner-container'}
      className={classNames('spinner', { 'absolute-center': absoluteCenter }, className)}
    >
      <div />
      <div />
      <div />
      <div />
    </SpinnerWrapper>
  );
};

export default Spinner;
